export { default } from './SpecialPagesList';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/SpecPages/SpecialPagesList/index.js